<nb-card>
    <nb-card-header>
        <div class="title">Section Builder - {{title}}</div>
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Save" (click)="onSave($event)" [disabled]="!canSave">
                    <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                </nb-action>
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="ref.close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <!-- <nb-card-header>{{contentType.value}} for Cell - {{selectedCell?.className | uppercase }}</nb-card-header> -->
    <div class="layout-container">
        <nb-sidebar left>
            <kve-editor-template-options [section]="section" [rendererType]="rendererType" orientation="vertical" [status]="status"></kve-editor-template-options>
        </nb-sidebar>
      <nb-sidebar right>
        <!-- <ng-container *ngIf="section.status !== 'In Progress'"> -->
            <nb-menu [items]="menuItems" tag="inputMenu"></nb-menu>
        <!-- </ng-container> -->
        
      </nb-sidebar>
      <div class="content">
        <div class="columns">
            <div class="preview-editor-container">
                <ng-container *ngIf="hasLoaded;else loading">
                    <kve-shared-section-builder [section]="section" (updateSection)="updateSection($event)">

                    </kve-shared-section-builder>
                </ng-container>
                <ng-template #loading>
                    <div class="loading-container">
                        <div>Loading</div>
                    </div>
                </ng-template>
            </div>    
        </div>

      </div>        
    </div>
    <!-- <nb-card-body>
        <div class="dialog-grid">
            <div class="input-cell">
                <ng-container *ngIf="cellElements?.length > 0">
                    <nb-accordion>
                        <nb-accordion-item *ngFor=" let cellElement of cellElements" class="grid-input-cell-element">
                            <nb-accordion-item-header>{{cellElement?.fieldName}}</nb-accordion-item-header>
                            <nb-accordion-item-body>
                                <kve-input-cell-editor [cellElement]="cellElement"></kve-input-cell-editor>  
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                    </nb-accordion>
                </ng-container>
            </div>
            <div class="preview-cell">
                <div class="editor-heading">Preview</div>
                <div class="nb-theme-default preview-container">
                    <div [ngClass]="selectedCell?.imageOrientation == 'landscape' ? 'landscape': 'portrait'">
                        <div class="view-port">shit goes here too</div>
                    </div>
                </div>
            </div>
            <div class="options-cell">Options Cell</div>
        </div>
    </nb-card-body> -->
    <nb-card-footer>
        {{section?.status}}
    </nb-card-footer>
</nb-card>
